<div class="indicators-status">
  <span *ngFor="let universeRight of universeRights">
    <app-indicator-status-item [flight]="flight" [universeRight]="universeRight"></app-indicator-status-item>
  </span>
</div>
